export default __webpack_public_path__ + "static/media/Angel with Voice.370cc902.mp4";